import { useMutation, useQueryClient } from 'react-query';
import {
  changeAutoTopUpProduct,
  type ChangeAutoTopUpProductResponse
} from '../../services/bettieAutoTopUpService';

export function useChangeAutoTopUpProduct() {
  const queryClient = useQueryClient();
  return useMutation<
    ChangeAutoTopUpProductResponse,
    Error,
    { bettieAutoTopUpId: string; productId: string }
  >(({ bettieAutoTopUpId, productId }) => changeAutoTopUpProduct(bettieAutoTopUpId, productId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['bettieAutoTopUp']);
    }
  });
}
